const eventTarget = new EventTarget();

export const dispatchDocumentChangeEvent = () => {
  eventTarget.dispatchEvent(new Event('documentChange'));
};

export const addDocumentChangeListener = (callback: () => void) => {
  eventTarget.addEventListener('documentChange', callback);
};

export const removeDocumentChangeListener = (callback: () => void) => {
  eventTarget.removeEventListener('documentChange', callback);
};
